import Quill from 'quill';
import { DOCUMENTATION_FONT_WHITELIST } from '../documentationFontOptions';
import { CalloutBlot } from './CalloutBlot';
import { CollapseBlot } from './CollapseBlot';
import { DividerBlot } from './DividerBlot';
import { TableBlot } from './TableBlot';

let registered = false;

export function registerQuillDocFormats(): void {
  if (registered) return;

  Quill.register(CalloutBlot, true);
  Quill.register(CollapseBlot, true);
  Quill.register(DividerBlot, true);
  Quill.register(TableBlot, true);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Size: any = Quill.import('attributors/style/size');
  Size.whitelist = ['12px', '14px', '16px', '18px', '24px', '32px'];
  Quill.register(Size, true);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Font: any = Quill.import('attributors/class/font');
  Font.whitelist = DOCUMENTATION_FONT_WHITELIST;
  Quill.register(Font, true);

  registered = true;
}
